import MemberLetter from '@/app/modules/pdf/components/pension-establishment/member-letter/member-letter.vue';
import Minutes from '@/app/modules/pdf/components/pension-establishment/minutes/minutes.vue';
import TrusteeLetter from '@/app/modules/pdf/components/pension-establishment/trustee-letter/trustee-letter.vue';
import Schedule from '@/app/modules/pdf/components/pension-establishment/schedule/schedule.vue';
import Pds from '@/app/modules/pdf/components/pension-establishment/pds/pds.vue';
import Pds2021 from '@/app/modules/pdf/components/pension-establishment/pds-2021/pds-2021.vue';
import Pds2022 from '@/app/modules/pdf/components/pension-establishment/pds-2022/pds-2022.vue';
import Pds2023 from '@/app/modules/pdf/components/pension-establishment/pds-2023/pds-2023.vue';
import PdsLatest from '@/app/modules/pdf/components/pension-establishment/pds-2024/pds-2024.vue';

export default {
  name: 'pension-establishment-pdf-container',
  components: {
    MemberLetter,
    Minutes,
    TrusteeLetter,
    Schedule,
    Pds,
    Pds2021,
    Pds2022,
    Pds2023,
    PdsLatest,
  },
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    pensionKit() {
      return this.$store.getters['toolkit/getItemData'];
    },
    scheduleRequired() {
      return this.pensionKit.setup.part !== 'PART_1';
    },
    startDate() {
      return this.pensionKit.requirements.startDate;
    },
    lessThan2021() {
      return new Date(this.startDate) < new Date(2021, 6, 1);
    },
    lessThan2022() {
      return new Date(this.startDate) < new Date(2022, 6, 1);
    },
    lessThan2023() {
      return new Date(this.startDate) < new Date(2023, 6, 1);
    },
    lessThan2024() {
      return new Date(this.startDate) < new Date(2024, 6, 1);
    },
  },
};
